import {
  WithStyles,
  withStyles,
  Button,
  Grid,
  Typography,

  FormControlLabel,
  Radio,
} from "@material-ui/core";
import cx from 'classnames';
import React, { Component } from "react";
import { connect } from "react-redux";
import { topNavStyles } from "../styles/topBarStyle";
import { MyPATDialog } from "../../common";
import DialogTopNav from "../common/DialogTopNav";
import CreateContentRequestPopup from "./CreateContentRequestPopup";
import  { contentRequestActions }  from "../reducers/contentRequestReducer.js";
import { Tabs } from "../types/Constants";
import { setActiveTab, updateCurrentPage } from "../actions/contentRequestActions";
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { isLoggedInUserCenterHead, isLoggedInUserMultiCenterHead } from "../helpers/createContentRequest";
import CustomInfoIcon from "../../common/CustomInfoIcon";
interface TopNavProps extends WithStyles<typeof topNavStyles> {
  setActiveTab: (tab:Tabs) => void,
  updateCurrentPage: Function,
  activeTab: any;
  receivedContentRequestsData:any
}

interface TopNavState {
  expandedFilter: boolean;
  openRequestPop:boolean;
  filterItems: Array<string>;
}

class TopNav extends Component<TopNavProps, TopNavState> {
  constructor(props: TopNavProps) {
    super(props);
    this.state = {
      expandedFilter: true,
      openRequestPop:false,
      filterItems: ["Important and urgent", "Not important but urgent", "Important but not urgent", "Not important and not urgent"]
    };
  }

  componentDidMount(){
    if(!isLoggedInUserCenterHead() && !isLoggedInUserMultiCenterHead()){
      this.props.setActiveTab(Tabs.ReceivedRequest);
    }
  }


  filterExpandClick = (value: any) => {
    this.setState({
      expandedFilter: !this.state.expandedFilter
    })
  }

  handleTopNav = () => {
    //add code
    this.setState({
      openRequestPop:true
    })
   
  }
  handleClosePopup = ()=>{
    this.setState({
      openRequestPop:false
    })
  }

  render() {  
    const { classes } = this.props;
    const { expandedFilter, filterItems,openRequestPop } = this.state;
     const noDataList =_.isEmpty(this.props.receivedContentRequestsData);
    
    return (
      <>
        <Grid container alignItems="center" spacing={24}>
          <Grid item xs={3} className={classes.infoIconAlign}>
            <Typography variant="h4" className={cx(classes.fontWeight600, classes.blackColor, classes.noWrap)}>
              Content Request&nbsp;
              <CustomInfoIcon
                  infoDialogContentType="Content Request"
                  isInfoIcon={true}
                  isRightArrow={false}
                  isCenterArrow={true}
                  knowMoreAbout={false}
                  dialogTitle="Content Request"
                  imageURL="/assets/svg/contentRequest/crIcon.svg"
                  dialogPara=""
                  details="Click to know more"
                  toolTipDirection="top"
                  htmlElement={
                    <>
                      <Grid container justify="center" className={classes.mtb30}>
                        <Typography className={classes.font16}>Through Content Request Module, authors can request other authors from same/different organization to create content via a defined workflow.
</Typography>
                        <Typography className={classes.font16}><strong>Note:</strong> Only Multi Centre Heads and Centre Heads can send a request</Typography>
                      </Grid>
                    </>
                  }
                />
            </Typography>
          </Grid>
          <Grid item xs={9}>
            <Grid container justify="space-between" alignItems="center">
          <Grid item >
            <Grid className={classes.paddingLeft56}>             
              { (isLoggedInUserMultiCenterHead() || isLoggedInUserCenterHead()) && <span className={this.props.activeTab === Tabs.ReceivedRequest ? cx(
                classes.cursorPointer,
                classes.link,
                classes.darkGrey,
                classes.activeTabStyle): cx(
                  classes.link,
                  classes.cursorPointer
                )}
                onClick={() => {this.props.setActiveTab(Tabs.ReceivedRequest)
                  this.props.updateCurrentPage(1);
                }
              }
                >
                My Tasks&nbsp;
                <span onClick={(e) => e.stopPropagation()}>
                  <CustomInfoIcon
                    infoDialogContentType="My Tasks"
                    isInfoIcon={true}
                    isRightArrow={false}
                    isCenterArrow={true}
                    knowMoreAbout={false}
                    dialogTitle="My Tasks"
                    imageURL="/assets/svg/contentRequest/receiveRequest.svg"
                    dialogPara="In My Tasks tab author will find the tasks assigned to him. As a Multi Centre Head/ Centre Head author will be able to see two kind of tasks- one which needs to be assigned to concerned content owners and the other which needs to completed as a part of content creation cycle."
                    details="Click to know more"
                    toolTipDirection="top"
                  />
                </span>
                    </span>}
              &nbsp;&nbsp;
                    { (isLoggedInUserMultiCenterHead() || isLoggedInUserCenterHead()) &&<span className={ this.props.activeTab === Tabs.SentRequest ? cx(
                    classes.link,
                    classes.cursorPointer, 
                      classes.darkGrey,
                      classes.activeTabStyle): cx(
                        classes.link,
                        classes.cursorPointer
                      )}
                    onClick={() => {this.props.setActiveTab(Tabs.SentRequest)
                      this.props.updateCurrentPage(1);
                    }}
                      >
                Assigned Tasks&nbsp;
                <span onClick={(e) => e.stopPropagation()}>

                  <CustomInfoIcon
                    infoDialogContentType="Assigned Tasks"
                    isInfoIcon={true}
                    isRightArrow={false}
                    isCenterArrow={true}
                    knowMoreAbout={false}
                    dialogTitle="Assigned Tasks"
                    imageURL="/assets/svg/contentRequest/sentRequest.svg"
                    dialogPara="In Assigned Tasks tab author can find all of the tasks assigned by him."
                    details="Click to know more"
                    toolTipDirection="top"
                  />
                </span>
                    </span>}
            </Grid>
          </Grid>
          <Grid item>
            { (isLoggedInUserMultiCenterHead() || isLoggedInUserCenterHead()) && <Grid>
              {
                // !noDataList &&
                <Button variant="contained" color="primary"
                className={cx(classes.primaryBtn, classes.fontWeight600)}
                onClick={this.handleTopNav.bind(this)}>
                Assign a new task
                    </Button>
                }
            </Grid>}
            {
              openRequestPop && 
              <CreateContentRequestPopup 
              createRequestOpen={openRequestPop}
              onClose={this.handleClosePopup}
              />
            }
          </Grid>          
          </Grid>
          </Grid>
        </Grid>

        
      </>
    )
  }
}

const mapStateToProps = (state: any) => ({
    activeTab: state.contentRequestReducer.contentRequestReducer.activeTab,
    receivedContentRequestsData: state.contentRequestReducer.contentRequestReducer.receivedContentRequestsData

});

const mapDispatchToProps = (dispatch: any) => bindActionCreators(
  {
    setActiveTab,
    updateCurrentPage
  },
  dispatch
);


export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(topNavStyles)(TopNav));
